import request from "@/api/request";

//刷新卡
export function refreshPhone() {
  return request({
    url: `/app/simCard/refreshPhone?card=${localStorage.getItem("meCardNum")}`,
  });
}

//卡详情
export function phoneSimCard() {
  return request({
    url: `/app/simCard/phoneSimCard?card=${localStorage.getItem("meCardNum")}`,
  });
}

//获取全部工单类型
export function selectAll() {
  return request({
    url: `/app/workOrderType/selectAll`,
  });
}

//工单详情
export function select(val) {
  return request({
    url: `/app/workOrder/user/select?id=${val}&card=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//工单列表
export function selectPage(val) {
  return request({
    url: `/app/workOrder/user/selectPage?card=${localStorage.getItem(
      "meCardNum"
    )}&state=${val}`,
  });
}

//获取套餐到期时间
export function getTime(val1, val2) {
  return request({
    url: `/app/orders/getTime?card=${localStorage.getItem(
      "meCardNum"
    )}&setmealId=${val1}&next=${val2}`,
  });
}

//卡余额变更
export function phoneBill(val) {
  return request({
    url: `/app/bill/phoneBill?card=${localStorage.getItem(
      "meCardNum"
    )}&isAdd=${val}`,
  });
}

// 绑定卡板
export function addCardSave(data) {
  return request({
    url: `/app/cardSave/addCardSave`,
    method: "post",
    data,
  });
}

//获取按键
export function getHide() {
  return request({
    url: `/app/icon/getHide?card=${localStorage.getItem("meCardNum")}`,
  });
}

//复机
export function start() {
  return request({
    url: `/app/autoTest/start?card=${localStorage.getItem("meCardNum")}`,
  });
}

//切换运营商
export function updateFalseOp(radio) {
  return request({
    url: `/app/simCard/updateFalseOp?meCardNum=${localStorage.getItem(
      "meCardNum"
    )}&falseOp=${radio}`,
  });
}

//卡套餐列表
export function getCategorySetMeal() {
  return request({
    url: `/app/category/getCategorySetMeal?meCardNum=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//支付卡套餐详情
export function phoneGetMeal() {
  return request({
    url: `/app/setmeal/phoneGetMeal?id=${Number(
      localStorage.getItem("meal")
    )}&card=${localStorage.getItem("meCardNum")}`,
  });
}

//卡套餐详情
export function phoneGetMeals(id) {
  return request({
    url: `/app/setmeal/phoneGetMeal?id=${id}&card=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//智能检测
export function autoTestCard(val) {
  return request({
    url: `/app/simCard/autoTestCard?card=${val}`,
  });
}

//公告列表
export function userSelectList() {
  return request({
    url: `/app/mnouncementModel/userSelectList?card=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//发送验证码
export function VerificationCode(val) {
  return request({
    url: `/app/simCard/VerificationCode?card=${localStorage.getItem(
      "meCardNum"
    )}&phone=${val}`,
  });
}

// 实名认证
export function updateRealType(data) {
  return request({
    url: `/app/simCard/updateRealType`,
    method: "post",
    data,
  });
}

//预存列表
export function prestoreGetAll() {
  return request({
    url: `/app/prestore/getAll?card=${localStorage.getItem("meCardNum")}`,
  });
}

//卡号常见问题
export function problemGetList(id) {
  return request({
    url: `/app/problemContent/getList?problemId=${id}`,
  });
}

//卡号问题表头
export function problemGetbyCard() {
  return request({
    url: `/app/problem/getbyCard?card=${localStorage.getItem("meCardNum")}`,
  });
}

//修改支付密码
export function updatePayPassWord(val1, val2) {
  return request({
    url: `/app/simCard/updatePayPassWord?meCardNum=${localStorage.getItem(
      "meCardNum"
    )}&oldPassWord=${val1}&newPassWord=${val2}`,
  });
}

//订单列表
export function phoneOrders() {
  return request({
    url: `/app/orders/phoneOrders?meCardNum=${localStorage.getItem(
      "meCardNum"
    )}`,
  });
}

//订单列表
export function selectByLiveId(val) {
  return request({
    url: `/app/livecodeContent/selectByLiveId?id=${val}`,
  });
}

//根据一级id获取二级菜单
export function getGuideTwoByGuideOneId(val1, val2) {
  return request({
    url: `/app/guideTwo/getGuideTwoByGuideOneId?guideOneId=${val1}&menuName=${val2}`,
  });
}

//引导页详情
export function guideInfo(val1) {
  return request({
    url: `/app/guide/guideInfo?id=${val1}`,
  });
}

// 引导页列表
export function guideOneList(data) {
  return request({
    url: `/app/guideOne/guideOneList`,
    method: "post",
    data,
  });
}

//获取流量
export function getCardFlow() {
  return request({
    url: `/app/simCard/getCardFlow?card=${localStorage.getItem("meCardNum")}`,
  });
}

//卡详情
export function phoneSimCards(val) {
  return request({
    url: `/app/simCard/phoneSimCard?card=${val}`,
  });
}

//卡详情
export function getRealName(val) {
  return request({
    url: `/app/simCard/getRealName?id=${val}`,
  });
}

//获取
export function getInfo(val) {
  return request({
    url: `/app/cardLiveCode/getInfo?card=${val}`,
  });
}

//兑换
export function useRedeemCode(val) {
  return request({
    url: `/app/redeemCode/useRedeemCode?redeemCode=${val}`,
  });
}

//兑换码设置详情
export function redeemCodeSettingsModel() {
  return request({
    url: `/app/redeemCodeSettings/redeemCodeSettingsModel`,
    method: "get",
  });
}

//三网切换获取卡详情
export function phoneSimCarda(value) {
  return request({
    url: `/app/simCard/phoneSimCard?card=${value}`,
  });
}

//链接地址
export function clientGets(val) {
  return request({
    url: `/app/seriesSettings/clientGet?card=${val}`,
  });
}

//卡全部套餐
export function cardMeal(val) {
  return request({
    url: `/app/simCard/getAutomaticOrdering?seriesId=${val}`,
  });
}

//卡绑定自动续费
export function setSetMealId(val, val1, val2) {
  return request({
    url: `/app/automaticOrdering/setSetMealId?setMealId=${val}&meCardNum=${val1}&payPassWord=${val2}`,
  });
}

//卡解绑定自动续费
export function delSetMealId(val1, val2) {
  return request({
    url: `/app/automaticOrdering/delSetMealId?meCardNum=${val1}&payPassWord=${val2}`,
  });
}
